import React from 'react';
import { graphql, useStaticQuery, Script } from 'gatsby';
import * as classes from './default.module.scss';
import logo from 'src/assets/logotype-white.svg';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import AppLink from 'src/components/base/appLink';
import 'styles/main.scss';

// TODO: [HAX-1705] Move the freshpaint env ids out into Environment Variables
const isProduction = process.env.NODE_ENV === 'production';
const fpProdId = '4e9f0595-bfca-4dd3-84ab-7c8d269a28dc';
const pfQaId = 'a8e35ca3-3292-43f5-9593-77a83bbbc4d8';
const fpLoaderSrc = isProduction ? '/boulder-care-fp.js' : '/boulder-care-fp-qa.js';
const fpSource = `https://freshpaint-cdn.com/js/${isProduction ? fpProdId : pfQaId}/freshpaint.js`;

const Layout = ({ children, location, pageTitle }) => {
  const data = useStaticQuery(
    graphql`
      query {
        datoCmsSite {
          faviconMetaTags {
            ...GatsbyDatoCmsFaviconMetaTags
          }
        }
        datoCmsStart {
          seoMetaTags {
            ...GatsbyDatoCmsSeoMetaTags
          }
        }
      }
    `,
  );

  return (
    <>
      <HelmetDatoCms seo={data.datoCmsStart.seoMetaTags}>
        <title>{pageTitle}</title>
        <script src={fpLoaderSrc} type="text/javascript" />
        <script src={fpSource} type="text/javascript" />
      </HelmetDatoCms>

      <div className={classes.app}>
        <header>
          <nav>
            <AppLink to="https://www.boulder.care/">
              <img alt="Boulder Care" src={logo} width="100" />
            </AppLink>
          </nav>
          <h1>{pageTitle}</h1>
        </header>
        <main className={classes.appMain}>{children}</main>
      </div>
    </>
  );
};

export default Layout;
